/* VEXiAL — el estado de la moneda (MONEDA.md §7).

   Qué moneda ve el cliente vive en tres sitios, y este archivo los
   mantiene de acuerdo:

     localStorage   vx_moneda = 'usd' | 'pen'
     atributo       <html data-vx-moneda="pen">, ausente = dólares
     evento         vx:moneda sobre document, con detail.moneda

   El atributo lo pone antes del primer pintado el script en línea de
   snippets/vx-moneda-head.liquid; aquí solo se cambia cuando el cliente
   toca un interruptor, cuando otra pestaña lo cambia (evento storage) o
   cuando el navegador devuelve la página desde su caché de historial.

   Cambiar de moneda no recalcula nada: los dos precios ya están pintados
   y el cambio es CSS (MONEDA.md §6.2). El evento es para lo poco que
   decide algo con el número, como el filtro de precio de la colección.

   Durante un cambio, html lleva un momento data-vx-moneda-cambio: es lo
   que dispara el estirón y el brillo de la perilla. El deslizamiento no lo
   necesita, porque es una transición sobre data-vx-moneda.

   También trae el tipo de cambio automático (MONEDA.md §2.7): consulta el
   dólar del día y se lo pasa a Liquid en un atributo de carrito, abajo del
   todo.

   Con la moneda apagada, snippets/vx-moneda-head.liquid ni siquiera carga
   este archivo; la guarda de abajo es por si alguien lo carga a mano. */
(function () {
  'use strict';

  var cfg = window.VX_MONEDA;
  if (!cfg || !cfg.activa) return;

  var CLAVE = 'vx_moneda';
  var raiz = document.documentElement;
  var tCambio = null;

  function actual() {
    return raiz.getAttribute('data-vx-moneda') === 'pen' ? 'pen' : 'usd';
  }

  function guardada() {
    try {
      return localStorage.getItem(CLAVE);
    } catch (e) {
      return null;
    }
  }

  /* aria-checked y tabindex siguen al atributo. Solo escribe lo que cambia:
     así el MutationObserver de <vx-moneda> no entra en bucle. */
  function sincronizar(ambito) {
    var m = actual();
    var opciones = (ambito || document).querySelectorAll('[data-vx-moneda-opcion]');
    for (var i = 0; i < opciones.length; i++) {
      var b = opciones[i];
      var on = b.getAttribute('data-vx-moneda-opcion') === m;
      var checked = on ? 'true' : 'false';
      var tab = on ? '0' : '-1';
      if (b.getAttribute('aria-checked') !== checked) b.setAttribute('aria-checked', checked);
      if (b.getAttribute('tabindex') !== tab) b.setAttribute('tabindex', tab);
    }
  }

  /* El estirón y el brillo duran lo que el viaje de la perilla. Si se cambia
     dos veces seguidas, la animación vuelve a empezar: quitar el atributo y
     forzar un cálculo de estilo antes de volver a ponerlo. */
  function marcarCambio() {
    raiz.removeAttribute('data-vx-moneda-cambio');
    void raiz.offsetWidth;
    raiz.setAttribute('data-vx-moneda-cambio', '');
    clearTimeout(tCambio);
    tCambio = setTimeout(function () {
      raiz.removeAttribute('data-vx-moneda-cambio');
    }, 600);
  }

  function aplicar(m) {
    m = m === 'pen' ? 'pen' : 'usd';
    if (m === actual()) {
      sincronizar();
      return;
    }
    if (m === 'pen') raiz.setAttribute('data-vx-moneda', 'pen');
    else raiz.removeAttribute('data-vx-moneda');
    marcarCambio();
    sincronizar();
    document.dispatchEvent(new CustomEvent('vx:moneda', { detail: { moneda: m } }));
  }

  function elegir(m) {
    try {
      localStorage.setItem(CLAVE, m === 'pen' ? 'pen' : 'usd');
    } catch (e) {}
    aplicar(m);
    /* En dólares la página no necesitaba el tipo de cambio del día; en
       soles, sí. */
    if (m === 'pen' && tasaNueva) recargarUnaVez(tasaNueva);
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-vx-moneda-opcion]') : null;
    if (!b) return;
    e.preventDefault();
    var m = b.getAttribute('data-vx-moneda-opcion');
    /* Con el puntero la píldora también es un interruptor: pulsar la moneda
       que ya está activa -- donde está la perilla -- pasa a la otra. Con el
       teclado no (e.detail es 0), para que Espacio sobre la opción marcada
       se comporte como en cualquier grupo de radios. */
    if (e.detail > 0 && m === actual()) m = m === 'pen' ? 'usd' : 'pen';
    elegir(m);
  });

  /* Un radiogroup se recorre con las flechas, y la flecha también elige. */
  document.addEventListener('keydown', function (e) {
    var k = e.key;
    if (k !== 'ArrowLeft' && k !== 'ArrowRight' && k !== 'ArrowUp' && k !== 'ArrowDown') return;
    var b = e.target && e.target.closest ? e.target.closest('[data-vx-moneda-opcion]') : null;
    if (!b) return;
    var grupo = b.closest('[role="radiogroup"]');
    var opciones = grupo ? grupo.querySelectorAll('[data-vx-moneda-opcion]') : [b];
    var i = Array.prototype.indexOf.call(opciones, b);
    var paso = k === 'ArrowLeft' || k === 'ArrowUp' ? -1 : 1;
    var siguiente = opciones[(i + paso + opciones.length) % opciones.length];
    e.preventDefault();
    elegir(siguiente.getAttribute('data-vx-moneda-opcion'));
    siguiente.focus();
  });

  /* Cambiar en una pestaña cambia las demás que estén abiertas. */
  window.addEventListener('storage', function (e) {
    if (e.key !== CLAVE && e.key !== null) return;
    aplicar(guardada() || cfg.defecto);
  });

  /* Al volver atrás, el navegador puede devolver la página tal como estaba,
     con la moneda de entonces. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) aplicar(guardada() || cfg.defecto);
  });

  /* El interruptor como elemento propio: al entrar en la página se pone de
     acuerdo con el atributo, y si un repintado de Shopify le devuelve el
     aria-checked del servidor, lo vuelve a corregir. */
  if (window.customElements && !window.customElements.get('vx-moneda')) {
    window.customElements.define('vx-moneda', class extends HTMLElement {
      connectedCallback() {
        var el = this;
        sincronizar(el);
        if (!el._vxObservador) {
          el._vxObservador = new MutationObserver(function () {
            sincronizar(el);
          });
        }
        el._vxObservador.observe(el, {
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-checked', 'tabindex']
        });
      }

      disconnectedCallback() {
        if (this._vxObservador) this._vxObservador.disconnect();
      }
    });
  }

  /* ── El tipo de cambio automático (MONEDA.md §2.7) ──────────────────
     El dólar del día lo consulta el navegador de cada visitante, lo guarda
     seis horas y se lo pasa a Liquid en el atributo de carrito _vx_tasa:
     «3.3613|1789400000», la tasa y la hora en que se leyó. Así lo que pinta
     el servidor —tarjetas, ficha, carrito, mensajes de WhatsApp— sale del
     mismo tipo de cambio que usa este JS. El margen y el paso siguen en los
     ajustes, fuera del alcance del visitante.

     La página que ya está pintada usó la tasa que traía el carrito, o la de
     respaldo si no traía ninguna. Si la del día difiere en medio céntimo o
     más y el cliente está viendo soles —o pasa a soles—, la página se
     recarga una vez para pintarse con la nueva. En dólares no hace falta:
     los soles no se ven. Si no se puede consultar, no pasa nada y queda la
     tasa de respaldo.

     Las fuentes son el espejo diario de currency-api (sin clave, con CORS) y
     su copia en jsDelivr, que puede ir un día por detrás. */
  var FUENTES = [
    'https://latest.currency-api.pages.dev/v1/currencies/usd.json',
    'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.json'
  ];
  var CLAVE_TASA = 'vx_tasa_dia';
  var CLAVE_RECARGA = 'vx_tasa_recarga';
  var VIGENCIA = 6 * 60 * 60 * 1000;
  var TOLERANCIA = 0.005;
  var tasaNueva = null;

  function tasaEnRango(t) {
    return typeof t === 'number' && isFinite(t) && t >= 2 && t <= 5.5;
  }

  function tasaGuardada() {
    try {
      var c = JSON.parse(localStorage.getItem(CLAVE_TASA) || 'null');
      if (c && tasaEnRango(c.tasa) && Date.now() - c.t < VIGENCIA) return c;
    } catch (e) {}
    return null;
  }

  function consultar(i) {
    if (i >= FUENTES.length) return Promise.resolve(null);
    return fetch(FUENTES[i], { cache: 'no-store', credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (j) {
        var tasa = j && j.usd ? Number(j.usd.pen) : NaN;
        if (!tasaEnRango(tasa)) throw new Error('Tasa fuera de rango');
        var c = { tasa: Math.round(tasa * 10000) / 10000, t: Date.now() };
        try {
          localStorage.setItem(CLAVE_TASA, JSON.stringify(c));
        } catch (e) {}
        return c;
      })
      .catch(function () {
        return consultar(i + 1);
      });
  }

  function escribirAtributo(c) {
    var tienda = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(tienda + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _vx_tasa: c.tasa.toFixed(4) + '|' + Math.floor(c.t / 1000) } })
    })
      .then(function (r) {
        return r.ok;
      })
      .catch(function () {
        return false;
      });
  }

  /* Una sola recarga por tasa y por sesión: si el servidor no tomara el
     atributo, no hay bucle. En el editor del tema, nunca. */
  function recargarUnaVez(c) {
    if (window.Shopify && window.Shopify.designMode) return;
    var marca = c.tasa.toFixed(4);
    try {
      if (sessionStorage.getItem(CLAVE_RECARGA) === marca) return;
      sessionStorage.setItem(CLAVE_RECARGA, marca);
    } catch (e) {
      return;
    }
    window.location.reload();
  }

  function tipoDeCambio() {
    if (!cfg.automatica) return;
    var guardada = tasaGuardada();
    (guardada ? Promise.resolve(guardada) : consultar(0)).then(function (c) {
      if (!c) return;
      var pagina = parseFloat(cfg.mercado);
      var diferencia = isFinite(pagina) ? Math.abs(pagina - c.tasa) : Infinity;
      if (cfg.fuenteTasa === 'automatico' && diferencia < 0.00005) return;
      escribirAtributo(c).then(function (ok) {
        if (!ok || diferencia < TOLERANCIA) return;
        tasaNueva = c;
        if (actual() === 'pen') recargarUnaVez(c);
      });
    });
  }

  sincronizar();
  tipoDeCambio();
})();
